module.exports = __webpack_public_path__ + "static/media/fan-4.49bc8b5d.png";